import styled from '@emotion/styled'
import { FlexColumn, FlexRow, SpaceBetweenRowContainer } from './Containers'
import BodyText, { MedBodyText, PageTitle, BoldBodyText } from './Text'

// Bill styles
const TotalsContainer = styled(FlexColumn)`
  padding: 0 30px;
`

const TotalDue = styled(PageTitle)`
  font-weight: 500;
`

const TotalAmount = styled(BoldBodyText)`
  font-size: 20px;
  font-weight: 500;
`

// Table specific styles
const TableContainer = styled(FlexColumn)`
  gap: 20px;
`

const RowContainer = styled.div`
  container-type: inline-size;
  width: 100%;
`

const Row = styled(SpaceBetweenRowContainer)`
  width: 100%;
  align-items: ${props => (props.editable ? 'start' : 'center')};

  @media only screen and (max-width: 600px) {
    flex-wrap: nowrap;
  }
`

const DataFields = styled(FlexRow)`
  width: 80%;
  align-items: ${props => (props.editable ? 'start' : 'center')};

  @container (max-width: 800px) {
    gap: ${props => (props.editable ? '5px' : '15px')};
  }
  @container (max-width: 700px) {
    flex-wrap: ${props => (props.editable ? 'wrap' : 'nowrap')};
  }
  @container (max-width: 500px) {
    flex-wrap: wrap;
    gap: 5px;
  }
`

const HeaderColumn = styled(BodyText)`
  flex-basis: ${props => props.basis || 'auto'};
  min-width: ${props => props.minwidth || '0'};
  word-break: break-word;

  @container (max-width: 500px) {
    flex-basis: 100%;
    font-size: 14px;
  }
`

const TotalHeaderText = styled(BodyText)`
  padding-right: ${props => (props.editable ? '49px' : '0')};

  @container (max-width: 500px) {
    font-size: 14px;
  }
`

const BoldDataColumn = styled(MedBodyText)`
  flex-basis: ${props => props.basis || 'auto'};
  min-width: ${props => props.minwidth || '0'};
  word-break: break-word;

  @container (max-width: 500px) {
    flex-basis: 100%;
    font-size: 12px;
    font-weight: 500;
  }
`

const DataColumn = styled(BoldDataColumn)`
  font-weight: 400;

  @container (max-width: 500px) {
    font-weight: 400;
  }
`

const Total = styled(FlexRow)`
  width: 20%;
  align-items: center;
  justify-content: flex-end;
  text-align: right;

  @container (max-width: 500px) {
    width: fit-content;
    text-wrap: nowrap;
  }
`

const LineTotalText = styled(BoldBodyText)`
  @container (max-width: 500px) {
    font-size: 14px;
  }
`

export {
  TotalsContainer,
  TotalDue,
  TotalAmount,
  TableContainer,
  RowContainer,
  Row,
  DataFields,
  HeaderColumn,
  TotalHeaderText,
  BoldDataColumn,
  DataColumn,
  Total,
  LineTotalText
}
